jQuery(document).ready(function($) {

	"use strict";

	$('.modal')
		.on('show.bs.modal hidden.bs.modal', function () {
			$(window).off('resize.bs.modal.center');
		})
		.on('show.bs.modal', function () {
			var modal = $(this);
			var modalDialog = modal.find('.modal-dialog');
			var modalContent = modal.find('.modal-content');

			var centerModal = function () {
				var dialogMargin = parseInt(modalDialog.css('margin-top'));
				var windowHeight = $(window).height();
				var contentHeight = modalContent.height();

				modalContent.css({
					'margin-top': Math.max(((windowHeight - contentHeight) / 2), dialogMargin)
				});
			};

			modal.one('shown.bs.modal loaded.bs.modal', centerModal);

			$(window).on('resize.bs.modal.center', centerModal);
		});

});
